import { lazy } from 'react';

export const StripelogPage = lazy(() => import('./page-list'));
